import { TransactionOperationType } from '../../enums';
export const formatInstructionNumber = (total) => {
    if (total >= 10)
        return ` (10+)`;
    if (total > 0)
        return ` (${total})`;
    return '';
};
export const getPaymentType = (t, type) => {
    switch (type) {
        case TransactionOperationType.BANKSLIP:
            return t('instructions-page.transaction-type.bankslip');
        case TransactionOperationType.PIX:
            return t('instructions-page.transaction-type.pix');
        case TransactionOperationType.TED:
            return t('instructions-page.transaction-type.ted');
        case TransactionOperationType.P2P:
            return t('instructions-page.transaction-type.p2p');
        default:
            return t('instructions-page.transaction-type.other');
    }
};
